const addCustomDimension = scope => (property, value) => ({
  [scope]: {
    [property]: value,
  },
});

export const addPageDimension = addCustomDimension('page');
export const addProductDimension = addCustomDimension('product');
export const addUserDimension = addCustomDimension('user');
